import { ReactNode } from "react";

type OverviewWidgetProps = {
	title: string | ReactNode,
	children?: ReactNode,
	className?: string
}

/**
 * Widget that provides an overview of a collection of information
 */
export function OverviewWidget(props: OverviewWidgetProps) {
	const { 
		title, 
		children, 
		className
	} = props;

	const rootClzName = `${className} overview-widget`;
	
	return (
		<div className={rootClzName}>
			{typeof title === "string" ? <h6>{title}</h6> : title}
			{children}
		</div>
	)
}